import styled from 'styled-components'

export const Tooltip = styled.div`
    background: #636363;
    color: white;
    font: 0.875 Avenir;
    vertical-align: center;
    padding: 12px;
    text-align: center;
    border-radius: 10px;
    margin-right: 12px;
    display: none;
    align-items: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    position: absolute;
    left: -11.5vw;
    margin-top: 15px;

    @media only screen and (max-width: 1440px) {
        width: 13vw;
        top: 10vh;
        right: 5vw;
    }
    @media only screen and (max-width: 1366px) {
        width: 14vw;
        top: 7.5vh;
        right: 5vw;
    }

    @media only screen and (max-width: 1024px) {
        width: 14vw;
        top: 9vh;
        right: 6vw;
    }

    @media only screen and (max-width: 992px) {
        width: 20vw;
        left: 5vw;
        top: 75vh;
    }
    @media only screen and (max-width: 800px) {
        width: 24vw;
        left: 5vw;
        top: 77vh;
    }
    @media only screen and (max-width: 700px) {
        top: 74vh;
        width: 28vw;
    }
    @media only screen and (max-width: 600px) {
        top: 70vh;
        width: 30vw;
    }
`
